// extracted by mini-css-extract-plugin
export default {"editableCellHover":"Accounting_editableCellHover__sySqT","table":"Accounting_table__olQXe"};